import { render, staticRenderFns } from "./BottonmMenu1Edit.vue?vue&type=template&id=18a15a4d"
import script from "./BottonmMenu1Edit.vue?vue&type=script&lang=js"
export * from "./BottonmMenu1Edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports